// core version + navigation, pagination modules:
import Swiper from "swiper";
import { Navigation, A11y } from "swiper/modules";

const performanceSlider = ($, $context = $(document)) => {
	const performanceSliders = $context.find(".js-performances-slider").toArray();

	if (!performanceSliders.length) return;

	performanceSliders.forEach((container) => {
		if (container.classList.contains("swiper-initialized")) return;

		// configure Swiper slider
		// eslint-disable-next-line no-unused-vars
		const swiper = new Swiper(container, {
			modules: [Navigation, A11y],
			a11y: {
				prevSlideMessage: "Previous slide",
				nextSlideMessage: "Next slide",
			},
			navigation: {
				prevEl: ".swiper-button-prev",
				nextEl: ".swiper-button-next",
			},
			slidesPerView: "auto",
			spaceBetween: 24,
		});
	});
};

export default performanceSlider;
